import { gql } from '@apollo/client';

export const DeleteProduct = gql`
mutation DeleteProduct($deleteProductId: ID!) {
  deleteProduct(id: $deleteProductId) {
    status
  }
}
`